//@flow
import * as React from 'react';
import classnames from 'classnames';
import { DivWithPopover } from 'common/components/core/wrappers/Div';
import { themr } from 'react-css-themr';
import { PopoverTriggerEnum } from 'common/components/core/popover/popOverFactory';

import theme from './InputCaretIcon.scss';

type InputCaretIconParams = {
    theme: Object,
    popOverContent: string,
    iconType: string,
    triggerPopoverOn: string,
    popOverContent: string,
    className?: string
};

export const IconTypes = {
    Error: 'error',
    Info: 'info'
};

const InputCaretIcon = ({
    popOverContent,
    theme,
    className,
    triggerPopoverOn,
    iconType,
    ...others
}: InputCaretIconParams) => {
    const iconTypeClass = theme[iconType];
    return (
        <DivWithPopover
            {...others}
            invert
            theme={theme}
            bgColor="salmon-two"
            triggerPopoverOn={triggerPopoverOn}
            popOverContent={popOverContent}
            className={classnames(theme.inputCaretIconWrap, {
                className,
                [iconTypeClass]: iconTypeClass
            })}
            icon="alert"
        >
            <div className={theme.inputCaretIcon} />
        </DivWithPopover>
    );
};

InputCaretIcon.defaultProps = {
    triggerPopoverOn: PopoverTriggerEnum.Hover,
    iconType: IconTypes.Error
};

const InputThemedCaretIcon = themr('InputCaretIcon', theme)(InputCaretIcon);

export { InputThemedCaretIcon as InputCaretIcon };
export default InputThemedCaretIcon;
